import { createReducer, on } from '@ngrx/store';

import * as fromPersistedStateActions from '../actions/persisted-state.actions';
import * as fromSettingActions from '../actions/setting.actions';

export const organizationFeatureKey = 'organization';

export interface State {
  alternateAppIconName: string | null;
  alternateAppIconPreviewUrl: string | null;
  applicationName: string | null;
  farmAlertsAutoSubscribe: boolean;
  farmAlertsEnabled: boolean;
  logoUrl: string | null;
  name: string | null;
  saleInformationEnabled: boolean;
  transactionHistoryEnabled: boolean;
  turnoverRateEnabled: boolean;
}

export const initialState: State = {
  alternateAppIconName: null,
  alternateAppIconPreviewUrl: null,
  applicationName: null,
  farmAlertsAutoSubscribe: false,
  farmAlertsEnabled: false,
  logoUrl: null,
  name: null,
  saleInformationEnabled: false,
  transactionHistoryEnabled: false,
  turnoverRateEnabled: false
};

export const reducer = createReducer(
  initialState,
  on(
    fromSettingActions.updateReferralCodeSuccess,
    fromSettingActions.loadSettingsSuccess,
    fromSettingActions.refreshReferralCodeSuccess,
    fromPersistedStateActions.migratePersistedOldStateReferralCodeSuccess,
    (state, { payload }) => ({
      ...state,
      alternateAppIconName: payload.data.organization.alternateAppIconName,
      alternateAppIconPreviewUrl: payload.data.organization.alternateAppIconPreviewUrl,
      applicationName: payload.data.organization.applicationName,
      farmAlertsAutoSubscribe: payload.data.organization.autoSubscribeFarmAlerts,
      farmAlertsEnabled: payload.data.organization.enableFarmAlerts,
      name: payload.data.organization.name,
      saleInformationEnabled: payload.data.organization.showComparableSalesProfileItem,
      transactionHistoryEnabled: payload.data.organization.showTransactionHistoryProfileItem,
      turnoverRateEnabled: !payload.data.organization.suppressTurnover
    })
  ),
  on(fromPersistedStateActions.loadPersistedStateFailure, fromPersistedStateActions.persistedStateReset, () => ({
    ...initialState
  })),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[organizationFeatureKey]
  }))
);
